import { NavLink, useLocation } from "react-router-dom";
import { LayoutGrid, Download, Check } from "lucide-react";

export function BottomNav() {
  const location = useLocation();
  // не показываем на login/block/location/details
  const hide = ["/client/login", "/client/block", "/client/location"].some((p) => location.pathname.startsWith(p)) ||
               /^\/client\/app\//.test(location.pathname);
  if (hide) return null;

  const items: { to: string; label: string; icon: typeof LayoutGrid; badge?: string }[] = [
    { to: "/client",           label: "Все",          icon: LayoutGrid },
    { to: "/client/updates",   label: "Обновления",   icon: Download, badge: "12" },
    { to: "/client/installed", label: "Установлено",  icon: Check },
  ];

  return (
    <nav className="border-t border-[var(--color-border)] bg-[var(--color-surface)]">
      <ul className="grid grid-cols-3">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <li key={it.to}>
              <NavLink
                to={it.to}
                end
                className={({ isActive }) =>
                  "flex flex-col items-center justify-center gap-1 py-2.5 text-[11px] transition-colors " +
                  (isActive ? "text-[var(--color-brand)]" : "text-[var(--color-fg-muted)]")
                }
              >
                {({ isActive }) => (
                  <>
                    <span className="relative">
                      <Icon size={20} strokeWidth={isActive ? 2.4 : 2} />
                      {it.badge && (
                        <span className="absolute -right-2 -top-1 grid h-4 min-w-[16px] place-items-center rounded-full bg-[var(--color-brand)] px-1 text-[9px] font-semibold text-white">
                          {it.badge}
                        </span>
                      )}
                    </span>
                    <span className={isActive ? "font-medium" : ""}>{it.label}</span>
                  </>
                )}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
